import styled from 'styled-components/macro'

const ContentsContainer = styled.section`
  width: 100%;
`

export const ChildrenScrollWrapper = styled.div<{ isChildrenExist: boolean }>`
  width: 100%;
  @media ${(props) => props.theme.media.xl} {
    ${(props) => (props.isChildrenExist ? 'overflow-x: scroll' : 'hidden')};
  }
`

const TableContainer = styled.div`
  position: relative;
  ::after {
    content: '';
    display: block;
    clear: both;
  }
`

export { ContentsContainer, TableContainer }
